<nav>
  <div class="brand-section">
    <img src="../../../assets/images/Pixel Pro Logo.png" routerLink="/" />
    <h1 class="text" routerLink="/">Pixel Pro</h1>
  </div>
  <ul class="desktop">
    <li
      class="text"
      routerLink="/smart-restaurant-suite"
      routerLinkActive="active"
    >
      Smart Restaurant Suite
    </li>
    <li class="text" routerLink="/about-us" routerLinkActive="active">
      About Us
    </li>
    <li class="text" routerLink="/contact-us" routerLinkActive="active">
      Contact Us
    </li>
  </ul>
  <div class="mobile">
    <button class="btn btn-menu" (click)="sidebarVisible = !sidebarVisible">
      <i class="pi pi-bars"></i>
    </button>
  </div>
</nav>
<p-sidebar [(visible)]="sidebarVisible" position="right">
  <div class="mobile border">
    <ul>
      <li
        class="text"
        routerLink="/smart-restaurant-suite"
        routerLinkActive="active"
        (click)="sidebarVisible = !sidebarVisible"
      >
        Smart Restaurant Suite
      </li>
      <li
        class="text"
        routerLink="/about-us"
        routerLinkActive="active"
        (click)="sidebarVisible = !sidebarVisible"
      >
        About Us
      </li>
      <li
        class="text"
        routerLink="/contact-us"
        routerLinkActive="active"
        (click)="sidebarVisible = !sidebarVisible"
      >
        Contact Us
      </li>
    </ul>
  </div>
</p-sidebar>
